import React from 'react'
import store from './store'
import useStorage from './hooks/useStorage'
import Login from './components/Login'
import { useAxios } from './hooks/useAxios'
import { getInitialized, setInitialized } from '@/store/slices/appSlice'
import {
  fetchConfigurationAsync,
} from '@/store/slices/userSlice'
import { fetchGetDataDictionaryAsync } from '@/store/slices/dataDictionarySlice'
import { useSelector } from 'react-redux'
import { Notification, Spin } from '@arco-design/web-react'
import { fetchGetMenuTreeAsync } from './store/slices/menuSlice'
import { getSetting } from '@/utils/settings'

const KEY_USER_INFO = getSetting('KEY_USER_INFO')
const KEY_TOKEN_LOGIN = getSetting('KEY_TOKEN_LOGIN')

export default function Auth (props) {
  const { children } = props
  const [userInfostr, setUserInfo, removeUserInfo] = useStorage(KEY_USER_INFO)
  const initialized = useSelector(getInitialized)
  const initAxios = useAxios()
  const dispatch = store.dispatch
  function checkLogin() {
    return !!localStorage.getItem(KEY_TOKEN_LOGIN)
  }
  async function initStoreFetch () {
    const proms = []
    proms.push(await dispatch(fetchConfigurationAsync()))
    proms.push(await dispatch(fetchGetDataDictionaryAsync()))
    proms.push(await dispatch(fetchGetMenuTreeAsync()))
   
    Promise.all(proms)
      .then((x) => {
        let hasError = false
        if (x) {
          x.forEach((c) => {
            if (c?.error?.message) {
              hasError = true
              Notification.error({
                title: '提示',
                content: c?.error?.message,
                position: 'bottomRight',
                duration: 0,
              })
            }
          })
        }
        hasError && console.error('缓存读取失败')
        !hasError && console.info('缓存读取成功')
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        dispatch(setInitialized(true))
      })
  }

  if (checkLogin()) {
    if (!initialized) {
      const userInfo = JSON.parse(userInfostr)
      initAxios(true)
      initStoreFetch()
    }
  } else {
    initAxios(false)
    return <Login />
  }
  return initialized ? (
    children
  ) : (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100vh',
      }}
    >
      <Spin dot tip="正在加载数据" />
    </div>
  )
}

